import { testimonials } from '@/mocks/comics';

export default function Testimonials() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20" aria-labelledby="reviews-title">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
            <i className="ri-heart-3-fill" aria-hidden="true"></i>
            用户口碑
          </span>
          <h2 id="reviews-title" className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
            五百万追更用户笑出声
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">
            每一条评论都是真实的笑声，专治不开心这件事，我们是认真的。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:gap-5 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:border-primary-300 hover:shadow-soft md:p-6"
            >
              <i className={`${t.icon} text-3xl text-secondary-300`} aria-hidden="true"></i>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 font-heading text-lg text-primary-700">
                  {t.avatar}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-900">{t.name}</span>
                  <span className="mt-0.5 flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-verified-badge-fill text-secondary-500" aria-hidden="true"></i>
                    已追更 · {t.role}
                  </span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}